import * as axios from './Axios'

const PREFIX = 'admin/portal'

export const _permissions = portal => axios.get(`${PREFIX}/${portal}/permissions`)
